import moment from 'moment';

const dateMixin = {
    methods: {
        // formatDate(date) { 
        //     const options = {year: 'numeric', month: 'long', day: 'numeric'};
        //     return new Intl.DateTimeFormat('de-DE', options).format(new Date(date));
        // },
        format(v) {
            return moment(v).format('llll')
        },
        formatOrderDate(v) {
            return moment(v).format('HH:mm DD/MM/yy');
        }
    }
}

export default dateMixin;